export default "__VITE_ASSET__aa7b7ea0__"